<template>
  <div class="view contentBody">
    <div class="title">名片管理</div>
    <div class="content">
      <div class="content-tab-box">
        <span :class="meaulistTab.firstTab==item?'content-tab-box-active':''" @click="tabCurrentFn(item)"
              v-for="(item,index) in meaulistTab.tab" :key="index">{{index}}</span>
      </div>
      <div v-for="item in meaulistTab.tab" :key="item">
        <component v-bind:is="item" v-if="meaulistTab.firstTab==item"></component>
      </div>
    </div>
  </div>
</template>
<script>
  import cardlist from "./cardlist.vue";
  import cardTags from "./cardTags.vue";
  import cardTitle from "./cardTitle.vue";
  let tabBox = {
    '名片管理': {property: 'cardlist'},
    '企业标签设置': {property: 'cardTags'},
    '名片模块': {property: 'cardTitle'}
  }

  export default {
    name: "card",
    components: {
      cardlist,
      cardTags,
      cardTitle
    },
    data() {
      return {
        meaulistTab: this.meaulist.meaulistGet(this, tabBox)
      };
    },
    created() {
      this.inittab();
    },
    methods: {
      inittab() {
        this.activeName =
            this.$route.query.tab !== undefined
                ? this.$route.query.tab
                : "cardlist";
      },
      tabCurrentFn(index) {
        this.meaulistTab.firstTab = index
      }
    }
  };
</script>
